import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ClinicOfficeListService } from 'src/shop-manager/services/clinic-office-list.service';
import { first, BehaviorSubject } from 'rxjs';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';

@Component({
    selector: 'app-export-csv-dialog',
    templateUrl: './export-csv-dialog.component.html',
    styleUrls: ['./export-csv-dialog.component.css'],
    standalone: false
})
export class ExportCsvDialogComponent
{
  loaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true)

  form: FormGroup = new FormGroup({
    country: new FormControl({ value: '', disabled: false }, [Validators.required]),
    type1: new FormControl('', [Validators.required]),
  })

  ShopTypesEnum = ShopTypesEnum
  CountriesIDs = COUNTRIES_IDS

  constructor(private dialogRef: MatDialogRef<any>, private clinicOfficeListService: ClinicOfficeListService) { }

  isDisabledButton(): boolean
  {
    let l_disabled = false
    if (!this.form.valid) l_disabled = true
    return l_disabled
  }

  onSubmit()
  {
    this.loaded.next(false)
    this.clinicOfficeListService.exportCSV(this.form.controls['type1'].value as ShopTypesEnum, this.form.controls['country'].value).pipe(first(l_resp => l_resp == true)).subscribe(l_resp =>
    {
      this.loaded.next(l_resp)
      this.dialogRef.close('Excelent')
    })

  }
}
